<template>
  <div class="page_main_wrap">
    <div class="global_header_wrap">
      <div class="platform_brand_wrap" @click="changeMenuCollapse">
        <div class="collapse_action_wrap" :class="{ 'is-collapse': isCollapse }">
          <span />
          <span />
          <span />
        </div>
        <div class="brand_text_wrap">
          <span class="brand_name">互联网医院处方流转平台</span>
          <span class="brand_subtitle">MEDICAL PRESCRIPTION PLATFORM</span>
        </div>
      </div>
      <div class="system_action_wrap">
        <div class="help_action_wrap">
          <i class="el-icon-question" />
          <span>帮助中心</span>
        </div>
        <div
          v-if="canOrderNotify"
          class="action_item_wrap notify_action_wrap"
          :class="{ active: notifyEnabled, ringing: newOrderCount > 0 }"
          @click="handleNotifyClick"
        >
          <el-badge :value="newOrderCount" :hidden="newOrderCount === 0" :max="99">
            <i :class="notifyEnabled ? 'el-icon-bell' : 'el-icon-turn-off'" />
          </el-badge>
          <span>{{ notifyEnabled ? '新订单提醒' : '提醒已关闭' }}</span>
        </div>
        <el-dropdown class="user_action_wrap" trigger="click" @command="handleDropdown">
          <div class="action_item_wrap">
            <i class="el-icon-user" />
            <span class="user_name">{{ loginName }}</span>
            <i class="el-icon-arrow-down" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">
              <i class="el-icon-switch-button" />
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="layout_body_wrap">
      <div class="page_menu_wrap" :class="{ 'is-collapse': isCollapse }" :style="{ width: menuWidth }">
        <div class="menu_main_wrap">
          <el-menu
            class="menu_group_wrap"
          active-text-color="#20a2a2"
          text-color="#334155"
            :router="true"
            :collapse-transition="false"
            :collapse="isCollapse"
            :default-active="defaultActiveRoute"
          >
            <el-menu-item v-for="(item, index) in menuLeft" :key="index" :index="item.route">
              <i class="icon_menu_left" :class="[item.icon, isElementIcon(item.icon) ? '' : 'iconfont']" />
              <span slot="title" class="menu_title">{{ item.title }}</span>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
      <div class="page_content_wrap">
        <div class="content_body_wrap">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/bus'
import newOrderNotify from '@/utils/newOrderNotify'

export default {
  data() {
    return {
      isCollapse: false,
      menuWidth: '148px',
      loginName: '',
      menuLeft: [],
      canOrderNotify: false,
      notifyEnabled: true,
      newOrderCount: 0
    }
  },
  computed: {
    defaultActiveRoute() {
      const menu = this.menuLeft.find(item => {
        return this.$route.path.includes(item.route)
      })
      const route = menu ? menu.route : undefined
      return route
    },
    isElementIcon() {
      return (icon = '') => icon.indexOf('el-icon-') === 0
    }
  },
  created() {
    const menuArr = [{
      route: '/home',
      title: '首页概览',
      icon: 'icon-home-page'
    }]
    const routeArr = ['/home', '/pharmacist/pharmacistDrugList', '/pharmacist/pharmacistDrugDetails', '/pharmacist/synchronousHospitalDrag', '/pharmacist/hospitalDrugAssociation']
    const buttonPermission = []
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.loginName = this.userInfo.loginName
    const menuList = this.userInfo.authInfoDTOS || []
    menuList.forEach(v => {
      menuArr.push({
        icon: v.path === '/erpChargebackList' ? 'el-icon-connection' : v.icon,
        route: v.path,
        title: v.authName,
        authInfo: v.authList
      })
      routeArr.push(v.path)
      if (v.authList.length) {
        v.authList.forEach(auth => {
          buttonPermission.push(auth.permission)
          if (auth.paths.length) {
            auth.paths.forEach(path => {
              routeArr.push(path)
            })
          }
        })
      }
    })
    this.menuLeft = menuArr
    const menuRouterArr = [...new Set(routeArr)]
    localStorage.setItem('ADMIN_MENU_ROUTER', JSON.stringify(menuRouterArr))
    localStorage.setItem('BUTTON_PERMISSION', JSON.stringify(buttonPermission))
    this.canOrderNotify = buttonPermission.includes('order-view-list')
    newOrderNotify.setAccount(this.userInfo.loginName)
    this.notifyEnabled = newOrderNotify.isEnabled()
  },
  mounted() {
    bus.$on('change-user-info', () => {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.loginName = this.userInfo.loginName
    })
    if (this.canOrderNotify) {
      newOrderNotify.start(count => {
        this.newOrderCount = count
      })
    }
  },
  beforeDestroy() {
    bus.$off(['change-user-info'])
    newOrderNotify.stop()
  },
  methods: {
    changeMenuCollapse() {
      this.isCollapse = !this.isCollapse
      this.menuWidth = this.isCollapse ? '52px' : '148px'
    },
    handleDropdown(command) {
      if (command === 'logout') {
        newOrderNotify.stop()
        this.$api.USER.logout({ accountId: this.userInfo.accountId }).then(res => {
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push({
            name: 'login'
          })
        }).catch(err => {
          console.log('err', err)
        })
      }
    },

    handleNotifyClick() {
      if (!this.notifyEnabled) {
        newOrderNotify.setEnabled(true)
        this.notifyEnabled = true
        newOrderNotify.unlockAudio()
        this.$message.success('新订单语音提醒已开启')
        return
      }
      if (!newOrderNotify.unlocked) {
        newOrderNotify.unlockAudio()
        this.$message.success('新订单语音提醒已开启')
        return
      }
      this.$confirm('关闭后将不再播放语音和弹窗提醒，是否继续？', '提示', {
        confirmButtonText: '关闭提醒',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        newOrderNotify.setEnabled(false)
        this.notifyEnabled = false
        this.newOrderCount = 0
        this.$message.info('新订单提醒已关闭')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="less">
.page_main_wrap {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f3f6f8;

  .global_header_wrap {
    height: 52px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    background: #fff;
    border-bottom: 1px solid #dfe6ee;
    box-shadow: 0 1px 5px rgba(15, 23, 42, 0.06);
    z-index: 10;

    .platform_brand_wrap {
      height: 40px;
      min-width: 254px;
      display: inline-flex;
      align-items: center;
      margin-right: auto;
      padding: 0 12px;
      border-radius: 10px;
      background: #eef9fa;
      cursor: pointer;

      .icon_logo {
        display: none;
        margin-right: 9px;
        font-size: 26px;
        line-height: 1;
        color: #20a2a2;
      }

      .collapse_action_wrap {
        width: 31px;
        height: 28px;
        display: inline-flex;
        flex-shrink: 0;
        flex-direction: column;
        justify-content: center;
        gap: 5px;
        margin-right: 9px;

        span {
          display: block;
          width: 30px;
          height: 3px;
          background: #20a2a2;
          border-radius: 3px;
          transition: width 0.16s ease, transform 0.16s ease, opacity 0.16s ease;
        }

        &.is-collapse {
          span:nth-child(1) {
            width: 18px;
            transform: translateX(12px);
          }

          span:nth-child(2) {
            width: 30px;
          }

          span:nth-child(3) {
            width: 18px;
          }
        }
      }

      .brand_text_wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-width: 0;

        .brand_name {
          color: #16989f;
          font-size: 16px;
          font-weight: 700;
          line-height: 18px;
          white-space: nowrap;
        }

        .brand_subtitle {
          margin-top: 1px;
          color: #65758a;
          font-size: 10px;
          line-height: 11px;
          letter-spacing: 1px;
          white-space: nowrap;
        }
      }
    }

    .system_action_wrap {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 14px;

      .collapse_action_wrap {
        width: 34px;
        height: 30px;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4px;
        cursor: pointer;
        border: 1px solid #d9e9f2;
        border-radius: 6px;
        background: #f3fbfb;
        transition: background-color 0.16s ease, border-color 0.16s ease;

        span {
          width: 17px;
          height: 2px;
          background: #20a2a2;
          border-radius: 2px;
          transition: width 0.16s ease, transform 0.16s ease;
        }

        &:hover {
          background: #e8f7f8;
          border-color: #bde6ea;
        }

        &.is-collapse {
          background: #fff;

          span:nth-child(1) {
            width: 10px;
            transform: translateX(3px);
          }

          span:nth-child(2) {
            width: 17px;
          }

          span:nth-child(3) {
            width: 10px;
            transform: translateX(-3px);
          }
        }
      }

      .help_action_wrap {
        height: 30px;
        display: flex;
        align-items: center;
        gap: 6px;
        color: #4b5563;
        font-size: 14px;
        white-space: nowrap;

        i {
          color: #64748b;
          font-size: 16px;
        }
      }

      .action_item_wrap {
        height: 30px;
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 0 12px;
        cursor: pointer;
        color: #4b5563;
        font-size: 14px;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 6px;

        &:hover,
        &.active {
          color: #20a2a2;
          background: #f3fbfb;
        }

        &.ringing {
          animation: notifyPulse 1.2s ease-in-out infinite;
        }

        i {
          color: inherit;
        }

        .user_name {
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .user_action_wrap {
        .action_item_wrap {
          height: 38px;
          padding: 0 12px 0 10px;
          color: #0f172a;
          font-weight: 600;
          background: #eef7fb;
          border-color: #d9e9f2;
          border-radius: 12px;

          .el-icon-user {
            width: 28px;
            height: 28px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 16px;
            background: #45bac2;
            border-radius: 50%;
          }
        }
      }
    }
  }

  .layout_body_wrap {
    flex: 1;
    min-height: 0;
    display: flex;
    overflow: hidden;
  }

  .page_menu_wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px 1px 10px 5px;
    background: #f3f6f8;
    box-sizing: border-box;
    transition: width 0.2s ease;

    &.is-collapse {
      padding: 10px 1px 10px 4px;

      .menu_main_wrap {
        padding: 10px 0;
        border-radius: 6px;
      }
    }

    .logo_main_wrap {
      width: 100%;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .icon_logo {
        margin-right: 8px;
        font-size: 24px;
        color: #fff;
      }

      .logo_info_wrap {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .logo_smart {
          font-weight: bold;
          font-size: 18px;
          color: #fff;
        }

        .logo_medical {
          font-weight: bold;
          font-size: 10px;
          color: #fff;
        }
      }
    }

    .menu_main_wrap {
      flex: 1;
      min-height: 0;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 12px 6px;
      background: #fff;
      border: none;
      border-radius: 6px;
      box-sizing: border-box;
      box-shadow: 0 1px 5px rgba(15, 23, 42, 0.07);

      .el-menu {
        border-right: none;
      }

      .menu_group_wrap {
        padding: 0;
        background: #fff;

        .el-menu-item {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          height: 36px;
          line-height: 36px;
          margin-bottom: 10px;
          padding-left: 10px !important;
          color: #334155;
          border-radius: 6px;
          box-sizing: border-box;
          transition: color 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;

          .icon_menu_left {
            width: 20px;
            height: 20px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-right: 8px;
            font-size: 17px;
            line-height: 1;
            color: inherit;
          }

          .menu_title {
            font-size: 13px;
            font-weight: 500;
            color: inherit;
            letter-spacing: 0;
          }

          &:hover {
            color: #20a2a2;
            background-color: #f4fcfc;
          }

          &.is-active {
            color: #20a2a2;
            background-color: #eefafa;
            box-shadow: inset 0 0 0 1px rgba(32, 162, 162, 0.08);

            &::before {
              position: absolute;
              left: 0;
              top: 7px;
              width: 3px;
              height: 22px;
              border-radius: 0 3px 3px 0;
              background: #20a2a2;
              content: '';
            }
          }
        }

        &.el-menu--collapse {
          width: 100%;
          min-width: 0;

          .el-menu-item {
            justify-content: center;
            width: 100%;
            height: 36px;
            line-height: 36px;
            margin-bottom: 10px;
            padding-left: 0 !important;
            padding-right: 0 !important;

            .icon_menu_left {
              width: 100%;
              height: 36px;
              margin-right: 0;
              font-size: 18px;
              line-height: 36px;
            }

            &.is-active {
              background-color: #eefafa;
              box-shadow: none;

              &::before {
                top: 50%;
                height: 20px;
                transform: translateY(-50%);
              }
            }
          }
        }
      }

      /deep/ .el-menu--collapse {
        width: 100%;

        .el-menu-item {
          min-width: 0;

          .el-tooltip {
            width: 100%;
            height: 36px;
            display: flex !important;
            align-items: center;
            justify-content: center;
            padding: 0 !important;
            box-sizing: border-box;
          }
        }
      }
    }
  }

  .page_content_wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    background: #f3f6f8;

    .content_body_wrap {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }
  }
}

@keyframes notifyPulse {
  0%, 100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.04);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue